export default {
  namespaced: true,
  stream_type: {
    title: "Stream type",
    master_account_title: "Default stream type",
    select_placeholder: "Select the stream types",
    inherited_from_master_account: "The master account ones will be used",
    none_configured: "No types configured, every available stream will be returned",
    order_help: "The list order is the order the streams are returned in.",
  },
};
